export const sendNotificationErrors = {
    productId: ['COUPON_WITH_ID_DOES_NOT_EXIST']
};
